export const INTERNAL_MESSAGE_PREFIX = '§'

export const HANDSHAKE_SUCCESS = 'HANDSHAKE_SUCCESS'
export const HANDSHAKE_FAILED = 'HANDSHAKE_FAILED'
export const PING = 'PING'
